<template>
  <div>
    <!-- <template v-if="obj.data.task.objectTypeId == 493">
       <label        
        class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0-f"
      >Холбоос</label>
      <div class="m-b-xs d-flex wd-100p">
          <router-link :to="{name: 'lmsCourseView', params:{id: parentTask.id, bid: boxId, iid: obj.data.task.id, bot: 493}}">Энд дарна уу</router-link>
        </div>
    </template> -->
    <!-- {{obj.data.task}} -->
    <div v-for="(f, i) in fields" :key="i">
      <!-- {{ f.flag }} -->
      <label
        v-show="f.flag != 8 && f.flag != 32 && f.flag != 36 && f.flag != 39"
        class="
          tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans
          mg-b-0-f
        "
        v-html="f.title" ></label
      >
      <p v-if="f.flag == 1" class="mg-b-20" v-html="obj.data.task[f.field]"></p>
      <div v-if="f.flag == 8" class="divider-text">{{ f.title }}</div>
      <!-- <div v-if="f.flag==9 && obj.data.task.ltFields!=null">{{obj.data.task.ltFields}}</div> -->
      <div v-if="f.flag === 11" :key="i">
        <div class="text-muted" style="width: 100%; display: flex">
          {{ f.title }}
        </div>
      </div>
      <div v-if="f.flag === 12" :key="i">
        <div style="display: flex">
          <div class="p-l-sm" v-if="obj.data.task[f.field] == 1">Тийм</div>
          <div class="p-l-sm" v-else-if="obj.data.task[f.field] == 0">Үгүй</div>
        </div>
      </div>
      <div v-if="f.flag === 13" :key="i">
        <div class="d-flex">
          <div
            class="p-l-sm"
            style="float: left; text-align: left; width: 70%; font-weight: 700"
            v-if="obj.data.task[f.field] == 1"
          >
            Excellent/Маш сайн
          </div>
          <div
            class="p-l-sm"
            style="float: left; text-align: left; width: 70%; font-weight: 700"
            v-else-if="obj.data.task[f.field] == 2"
          >
            Good/Сайн
          </div>
          <div
            class="p-l-sm"
            style="float: left; text-align: left; width: 70%; font-weight: 700"
            v-else-if="obj.data.task[f.field] == 3"
          >
            Fair/Дунд
          </div>
          <div
            class="p-l-sm"
            style="float: left; text-align: left; width: 70%; font-weight: 700"
            v-else-if="obj.data.task[f.field] == 4"
          >
            Poor/Муу
          </div>
        </div>
      </div>
      <div v-if="f.flag === 14">
        <div class="m-b-xs d-flex wd-100p">
          <b>{{ f.title }}</b>
        </div>
      </div>
      <div v-if="f.flag === 15">
        <div class="m-b-xs" style="text-align: right">
          <img :src="obj.data.task[f.field] + '?w=120'" />
        </div>
      </div>
      <div v-if="f.flag === 21">
        <div class="m-b-xs d-flex">
          <div
            class="p-l-sm"
            style="float: left; text-align: left; width: 70%; font-weight: 500"
          >
            {{ obj.data.task[f.field] | moment("YYYY") }}
          </div>
        </div>
      </div>
      <p v-else-if="f.flag == 22" class="mg-b-20">
        {{ obj.data.task[f.field] | moment("YYYY.MM.DD") }}
      </p>
      <p v-else-if="f.flag == 23" class="mg-b-20">
        {{ obj.data.task[f.field] | moment("dddd, YYYY.MM.DD HH:mm") }}
      </p>
      <p v-else-if="f.flag == 24" class="mg-b-20 tx-brand-01" role="button">
        <template v-if="obj.data.task[f.field] != null">
          <div @click="$emit('on-attach', obj.data.task[f.field])">
            <feather class="wd-16 ht-16" type="paperclip"></feather>файл харах
          </div>
        </template>
      </p>
      <p
        @click="
          $emit('on-task-detail', { obj: obj.data.task[f.field], mode: 80 })
        "
        v-else-if="f.flag == 25"
        class="mg-b-20 tx-brand-01"
        role="button"
      >
        <template v-if="obj.data.task[f.field] != null">
          <feather class="wd-16 ht-16" type="external-link"></feather>
          <template v-if="obj.data.task[f.field]['objectTypeId'] == 506">
            <span v-show="obj.data.task[f.field]['taskEn'] != null"
              >{{ obj.data.task[f.field]["taskEn"] }} -
            </span>
            {{ obj.data.task[f.field]["task"] }}
          </template>
          <template v-else>
            <span v-show="obj.data.task[f.field]['prefix'] != null"
              >{{ obj.data.task[f.field]["prefix"] }} -
            </span>
            {{ obj.data.task[f.field]["task"] }}
          </template>
        </template>
      </p>
      <div v-if="f.flag === 27">
        <div
          v-if="
            obj.data.task.isTender != true &&
            hasPermission(['cashAdminAAA11', 'cashadmin', 'admin'])
          "
        >
          <button
            type="button"
            class="btn btn-xs btn-outline-primary"
            @click="payByCash()"
          >
            Бэлнээр төлөх
          </button>
          <!-- <button
                type="button"
                class="ivu-btn ivu-btn-success"
                @click="checkInvoice()"
              >Төлбөр шалгах</button> -->
        </div>
        <div v-else>
          <!-- <button
                type="button"
                class="ivu-btn ivu-btn-success"
                @click="checkInvoice()"
              >Төлбөр төлөх</button> -->
        </div>
        <div>
          <span v-if="obj.data.task.isTender" class="badge badge-success"
            >Төлсөн</span
          >
          <span class="badge badge-warning" v-else>Төлөөгүй</span>
        </div>
      </div>
      <div v-if="f.flag == 39" class>
        <div class="card" v-if="obj.data.task.column != null">
          <div
            class="
              card-header
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <h6 class="mg-b-0">{{ f.title }}</h6>
          </div>
          <ul
            v-if="
              obj.data.task.lastTransferUser != undefined &&
              obj.data.task.lastTransferUser != null
            "
            class="list-group list-group-flush tx-13"
          >
            <li class="list-group-item d-flex pd-sm-x-20">
              <div class="avatar">
                <img
                  :src="obj.data.task.lastTransferUser.avator"
                  class="rounded-circle"
                />
              </div>
              <div class="pd-l-10">
                <p class="tx-medium mg-b-0">
                  {{ obj.data.task.lastTransferUser.fullName }}
                </p>
                <small class="tx-12 tx-color-03 mg-b-0">{{
                  obj.data.task.lastTransferDate | moment("YYYY.MM.DD HH:mm")
                }}</small>
              </div>
            </li>
          </ul>
          <div class="pd-10">
            <div
              v-if="
                obj.data.task.lastTransferMsg != null &&
                obj.data.task.lastTransferMsg.length > 0
              "
              class="alert alert-warning mg-b-10"
              role="alert"
            >
              <p class="mg-b-0">
                <b class="pd-r-10">Тайлбар:</b>
                {{ obj.data.task.lastTransferMsg }}
              </p>
            </div>

            <div
              v-if="obj.data.task.column != null"
              class="alert alert-info"
              role="alert"
            >
              <p class="mg-b-0">
                <b class="pd-r-10">Дуусгах хугацаа:</b>
                {{ obj.data.task.column.dueDate | moment("YYYY.MM.DD HH:mm") }}
              </p>
            </div>
          </div>
        </div>

        <div v-else-if="obj.data.task.isCompleted">
          <div class="card">
            <div
              class="
                card-header
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <h6 class="mg-b-0">Дуусгасан</h6>
            </div>
            <ul
              v-if="obj.data.task.completedUser != null"
              class="list-group list-group-flush tx-13"
            >
              <li class="list-group-item d-flex pd-sm-x-20">
                <div class="avatar">
                  <img
                    :src="obj.data.task.completedUser.avator"
                    class="rounded-circle"
                  />
                </div>
                <div class="pd-l-10">
                  <p class="tx-medium mg-b-0">
                    {{ obj.data.task.completedUser.fullName }}
                  </p>
                  <small class="tx-12 tx-color-03 mg-b-0 text-truncate"
                    >{{ obj.data.task.completedUser.departName }} /
                    {{ obj.data.task.completedUser.position }}</small
                  >
                </div>
              </li>
            </ul>
            <div class="pd-10">
              <div
                v-if="
                  obj.data.task.completedDesc != null &&
                  obj.data.task.completedDesc.length > 0
                "
                class="alert alert-success mg-b-10"
                role="alert"
              >
                <p class="mg-b-0">
                  <b class="pd-r-10">Тайлбар:</b
                  >{{ obj.data.task.completedDesc }}
                </p>
              </div>
              <div class="alert alert-success mg-b-10" role="alert" v-else>
                <p class="mg-b-0">
                  <b class="pd-r-10">Тайлбар:</b>тайлбар оруулаагүй
                </p>
              </div>

              <div class="alert alert-info" role="alert">
                <p class="mg-b-0">
                  <b class="pd-r-10">Дуусгасан хугацаа:</b>
                  <span :title="obj.data.task.completedAt | moment('LLLL')">{{
                    obj.data.task.completedAt | moment("YYYY.MM.DD HH:mm")
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="f.flag == 34" class="bg-white" role="alert">
        <div style="display: inline-block" v-for="(tg, tgi) in obj.data.task[f.field]" :key="tgi"
        class="tx-12 rounded-5 mg-r-5 mg-b-5 pd-x-5 pd-y-3 bg-light">{{ tg.name }}</div>
      </div>
      <div v-if="f.flag == 36" class="alert alert-secondary" role="alert">
        <h6 class="alert-heading">{{ f.title }}</h6>
        <p v-html="f.helpInfo"></p>
      </div>
      <div v-if="f.flag == 42">
        <video-conference :task.sync="obj.data.task"></video-conference>
      </div>
      <div v-else-if="f.flag === 44" class="alert alert-success">
        <div v-if="obj.data.task.f1 != null">
          <div class="d-flex">
            <div class="">Төрөл: </div>
            <div class="" style="font-weight: 700">
              <template v-if="obj.data.task.objectTypeId == 343">
                {{
                  obj.data.task.s11 == "1" || obj.data.task.i3 == 1
                    ? ("Байгууллага (" + obj.data.task.st2 + ")")
                    : "Хувь хүн"
                }}
              </template>
              <template v-else-if="obj.data.task.objectTypeId == 532">
                Байгууллага
              </template>
              
            </div>
          </div>
          <hr />
          <div class="btn-group wd-100p">
            <a
              role="button"
              @click="$emit('ebarimt-return', obj.data.task)"
              class="btn btn-xs btn-outline-danger m-l-md btn-lowercase wd-50p"
              >Цуцлах</a>
              <a
              role="button"
              @click="$emit('ebarimt-print', obj.data.task)"
              class="btn btn-xs btn-primary m-l-md btn-lowercase wd-50p"
              >Хэвлэх</a>
          </div>
        </div>
        <div v-else class="text-center">
          <template v-if="obj.data.task.objectTypeId == 343">
            Олгогдоогүй байгаа
          </template>
          <template v-else-if="obj.data.task.objectTypeId == 532">
            <a
              @click="createPackageInvoiceEbarimt()"
              role="button"
              class="btn btn-sm btn-success m-l-md"
              >И-Баримт шивэх</a
            >
          </template>
        </div>
      </div>
      <div v-if="f.flag === 45">
        <div class="m-b-xs" style="display: flex">
          <!-- <div style="float:left; width: 30%; text-align: right" class="text-muted">{{f.title}}:</div> -->
          <div
            class="p-l-sm"
            style="float: left; text-align: left; width: 70%; font-weight: 700"
          >
            <!-- <a target="_blank" :href="`https://zoom.gosmart.mn/meeting.html?name=${$store.state.user.userInfoFull.fullName}&mn=${task.st1}&email=${$store.state.user.mail}&pwd=${task.st2}&role=1&lang=en-US&apiKey=${task.s3}&apiSecret=${task.s4}`">энд дарна уу</a> -->
            <router-link
              :to="`/lms/courseView/${parentTask.id}/${boxId}/${obj.data.task.id}/${obj.data.task.objectTypeId}`"
              >энд дарна уу</router-link
            >
          </div>
        </div>
      </div>
      <div v-if="f.flag === 46">
        <div class="mg-b-20">
          <div>
            <div v-if="bookInfo.rdy" class="bg-white bd rounded pd-10">
              <ul class="list-group list-unstyled mg-b-10">
                <li>Төрөл: {{ bookInfo.data.typeFlatted }}</li>
                <li>Байршил: {{ bookInfo.data.locationFlatted }}</li>
                <li>Нийт: {{ bookInfo.data.total }}</li>
                <li>Үлдэгдэл: {{ bookInfo.data.too1 }}</li>
              </ul>

              <div class="btn-group" v-if="obj.data.task.i1 == 1">
                <button
                  @click="bookCmd(0)"
                  class="btn btn-xs btn-uppercase btn-success"
                >
                  Хүлээн авах
                </button>
              </div>
              <div v-else-if="obj.data.task.i1 == 0" class="bd-t pd-t-10">
                <div class="d-flex align-items-center">
                  <div class="mg-r-5">Хугацаа:</div>
                  <DatePicker
                    size="mini"
                    v-model="obj.data.task.d3"
                    placeholder="Огноо сонгоно уу"
                    type="date"
                    style="width: 100%"
                    :format="'yyyy-MM-dd'"
                    :value-format="'yyyy-MM-dd'"
                  ></DatePicker>
                </div>
                <div class="btn-group mg-t-10">
                  <button
                    @click="bookCmd(-1)"
                    class="btn btn-xs btn-uppercase btn-warning"
                  >
                    Цуцлах
                  </button>
                  <button
                    @click="bookCmd(1)"
                    class="btn btn-xs btn-uppercase btn-success"
                  >
                    Олгох
                  </button>
                </div>
              </div>
              <div
                class="d-flex align-items-center bd-t pd-t-10"
                v-if="obj.data.task.i1 == 2"
              >
                <span class="badge badge-success">Хүлээн авсан</span>
                <div class="mg-l-auto">
                  {{ obj.data.task.d2 | moment("YYYY.MM.DD HH:mm, dddd") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="f.flag == 48" class="mg-b-20">
        <GmapMap
          v-if="googleMapRdy"
          :center="{
            lat:
              obj.data.task.lat != null
                ? parseFloat(obj.data.task.lat)
                : 47.9138932,
            lng:
              obj.data.task.lng != null
                ? parseFloat(obj.data.task.lng)
                : 106.8986408,
          }"
          :zoom="13"
          map-type-id="satellite"
          style="width: 100%; height: 300px"
        >
          <GmapMarker
            v-for="(m, i) in googleMapMaker"
            :key="i"
            :position="m.position"
          />
        </GmapMap>
      </div>
      <div v-else-if="f.flag == 49" class="mg-b-20">
        <a
          @click="
            $emit('on-show-value', {
              field: f.title,
              value: obj.data.task[f.field],
            })
          "
          class="btn btn-block btn-outline-primary btn-xs btn-uppercase"
          >{{ f.title }} харах</a
        >
      </div>
      <div v-else-if="f.flag == 50" class="mg-b-20">
        <table
          v-if="obj.data.task.ltFields != null"
          class="table tabl-bordered mg-t-10-f mg-b-0-f"
        >
          <tbody>
            <tr v-for="(ltField, i) in obj.data.task.ltFields" :key="`lt_` + i">
              <td width="40%">
                <label
                  class="
                    tx-10
                    tx-medium
                    tx-spacing-1
                    tx-color-03
                    tx-uppercase
                    tx-sans
                    mg-b-0-f
                  "
                  >{{i+1}}. {{ ltField.property.title }}</label
                >
              </td>
              <td>
                <div v-if="ltField.property.type==6 && ltField.property.selectedValues.length" class="d-flex align-items-center vertical-align-middle" role="button"
                  @click="$emit('on-attach', parseInt(ltField.property.selectedValues[0]['value'], 10) )">
                  <a class="tx-medium mg-r-5">
                    Файл харах 
                  </a>
                  <feather type="arrow-right" style="margin-top: -6px"></feather>
                </div>
                <div v-else
                  v-for="(value, vi) in ltField.property.selectedValues"
                  :key="`lt_` + vi" class="rounded bg-light tx-11 pd-y-2 pd-x-10"
                  >{{ value.value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <p v-else class="text-muted">...</p> -->
    </div>
    <div
      v-if="
        obj.data.task.objectTypeId == 138 && hasPermission(['admin', 'hradmin'])
      "
      class="pd-20"
    >
      <div class="divider-text">Төлөв</div>

      <div
        v-if="activationObj.loading"
        class="ivu-spin ivu-spin-large ivu-spin-fix"
      >
        Мэдээлэл шалгаж байна...
      </div>
      <div
        v-if="activationObj.flag == 0"
        class="alert alert-success align-items-center"
        role="alert"
      >
        <h4 class="alert-heading">Баталгаажсан</h4>
        <feather type="check" class="mg-r-10"></feather>Хэрэглэгчийн системд
        баталгаажсан.
      </div>
      <div
        v-else-if="activationObj.flag == -900"
        class="alert alert-warning align-items-center"
        role="alert"
      >
        <h4 class="alert-heading">Баталгаажаагүй</h4>
        <p>
          Та хэрэглэгчийн өмнөөс баталгаажуулах үйлдлийг гүйцэтгэх бол
          <b>{{ activationObj.code }}</b> кодыг ашиглана уу !
        </p>
      </div>
      <div class="mg-t-5" v-if="activationObj.flag == -900">
        <div class="input-group">
          <input
            v-model="activationObj.key"
            type="text"
            class="form-control"
            placeholder="Баталгаажуулах код оруулна уу..."
            aria-label="Баталгаажуулах код оруулна уу..."
            aria-describedby="button-addon2"
          />
          <div class="input-group-append">
            <button
              @click="forceActivation()"
              class="btn btn-outline-light"
              type="button"
              id="button-addon2"
            >
              Баталгаажуулах
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videoConference from "@/components/modules/videoConference";
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Notification } from "element-ui";
import { mapActions } from "vuex";

const moment = require("moment");

export default {
  components: {
    videoConference,
    DatePicker,
    Notification,
  },
  props: {
    obj: {
      type: Object,
      default: () => {},
    },
    boxId: {
      type: Number,
      default: () => 0,
    },
    parentTask: {
      type: Object,
      default: () => {},
    },
    fields: {
      type: Array,
      default: () => [],
    },
    loaded: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      activationObj: {
        flag: -1,
        key: "",
        code: "",
        loading: false,
      },
      bookInfo: {
        data: {},
        rdy: false,
      },
      googleMapMaker: [],
      googleMapRdy: false,
    };
  },
  mounted() {
    if (this.obj.data.task.objectTypeId == 138) {
      this.initActivation();
    }
    if (this.obj.data.task.objectTypeId == 504) {
      this.getBookUldegdel();
    }

    if (this.obj.data.task.lat != null && this.obj.data.task.lng != null) {
      this.googleMapMaker = [
        {
          position: {
            lat: parseFloat(this.obj.data.task.lat),
            lng: parseFloat(this.obj.data.task.lng),
          },
        },
      ];
      this.$nextTick(() => {
        this.googleMapRdy = true;
      });
    }
  },
  methods: {
    ...mapActions(["handleLoading"]),
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    createPackageInvoiceEbarimt() {
      this.handleLoading({ isLoading: true });
      request({
        data: { id: this.obj.data.task.id },
        api: { url: "EBarimt/CreatePackInvoiceBill", method: "post" },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          Notification.success({
            title: "Амжилттай",
            message: `И-баримт амжилттай шивэгдлээ.`,
            duration: 10000,
            position: "bottom-left",
          });

          this.$emit("on-reload", {mode: 0, obj: {id: this.obj.data.task.id}});
        }
      });
    },
    payByCash() {
      var desc = prompt("Тайлбар оруулна уу", "");
      if (desc != null) {
        let link = "Payment/payByCash";
        if (this.obj.data.task.objectTypeId == 532)
          link = "Payment/PayPackageInvoiceByCash";
        request({
          data: { invoiceId: this.obj.data.task.id, desc: desc },
          api: { url: link, method: "post" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.$emit("on-task-field-set-local", {
              fieldName: "isTender",
              value: true,
            });
            //this.obj.data.task.isTender = true;
          }
        });
      }
    },
    // TODO: tolbor oruulj irsen uyed hiih
    // checkInvoice() {
    //   this.paymentVisible = true;
    // },
    forceActivation() {
      request({
        data: {
          key: this.activationObj.key,
          groupId: this.obj.data.task.groupId,
          userId: this.obj.data.task.userId,
        },
        api: { url: "user/activate", method: "post" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.initActivation();
        }
      });
    },
    initActivation() {
      this.activationObj.loading = true;
      request({
        data: { userId: this.obj.data.task.userId },
        api: { url: "auth/CheckActivation", method: "post" },
        store: this.$store,
      }).then((res) => {
        this.activationObj.loading = false;
        if (res != false) {
          if (res.data.flag == -900) {
            this.activationObj.flag = res.data.flag;
            this.activationObj.code = res.data.key;
          } else {
            this.activationObj.flag = res.data.flag;
          }
        }
      });
    },
    getBookUldegdel() {
      request({
        params: {
          id: this.obj.data.task.organizationTaskId,
        },
        api: { url: "library/BookDetail", method: "GET" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.bookInfo.data = res.data.book;
          this.bookInfo.rdy = true;
          if (this.obj.data.task.i1 == 0) {
            this.obj.data.task.d3 = moment(new Date(), "DD-MM-YYYY")
              .add(3, "days")
              .format("YYYY-MM-DD");
          }
        }
      });
    },
    bookCmd(mode) {
      if (mode == 1) {
        request({
          data: {
            id: this.obj.data.task.id,
            date: this.obj.data.task.d3,
          },
          api: { url: "library/AcceptOrder", method: "POST" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.bookCmdAfter(res);
          }
        });
      } else if (mode == -1) {
        request({
          data: {
            id: this.obj.data.task.id,
          },
          api: { url: "library/DeclineOrder", method: "POST" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.bookCmdAfter(res);
          }
        });
      } else if (mode == 0) {
        request({
          data: {
            id: this.obj.data.task.id,
          },
          api: { url: "library/GiveBackTheBook", method: "POST" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.bookCmdAfter(res);
          }
        });
      }
    },
    bookCmdAfter(res) {
      this.$emit("on-reload", this.obj.data.task);
      Notification.info({
        message: res.msg,
        duration: 30000,
        type: "info",
        position: "top-right",
        offset: 50,
      });
    },
  },
};
</script>
